// @owners { team: patients }
export const IMAGE_DIMENSIONS = {
  width: 328,
  height: 268,
};
